import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';

import { getUser } from 'api/login';
import logout from 'modules/authentication/actions/logout';
import useNetworkState from 'hooks/useNetworkState';
import TailwindcssBlock from 'components/Tailwindcss/Block';
import { ReactComponent as Logo } from 'images/clubes-logo.svg';
import { ReactComponent as Spinner } from 'images/animated-spinner.svg';

const Protected = ProtectedComponent => props => {
  const dispatch = useDispatch(); // eslint-disable-line react-hooks/rules-of-hooks
  const [verified, setVerified] = useState(false); // eslint-disable-line react-hooks/rules-of-hooks
  const { isLoading, setIsLoading, setDoneLoading, setFailedLoading } = useNetworkState(); // eslint-disable-line react-hooks/rules-of-hooks
  const { history, location } = props;

  // eslint-disable-next-line react-hooks/rules-of-hooks
  useEffect(() => {
    setIsLoading();

    getUser()
      .then(response => {
        setDoneLoading();
        if (response.status === 401) {
          history.replace({ pathname: '/', state: { fromPage: location.pathname } });
          dispatch(logout());

          return null;
        }

        setVerified(true);
      })
      .catch(_ => {
        setFailedLoading();
      });
  }, []); // eslint-disable-line

  if (isLoading || !verified) {
    return (
      <TailwindcssBlock
        useDivTag
        bg-gray-400
        fixed
        top-0
        left-0
        right-0
        bottom-0
        flex
        justify-center
        items-center
      >
        <div>
          <Logo />
          <TailwindcssBlock useDivTag mt-4>
            <Spinner className="w-10 h-10" />
          </TailwindcssBlock>
        </div>
      </TailwindcssBlock>
    );
  }

  return <ProtectedComponent {...props} />;
};

export default Protected;
